import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyAQKGhrrEfs4Np7mLo5zFb4D1NOb05krlY",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "bonusbuddy-a2085.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "bonusbuddy-a2085",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "bonusbuddy-a2085.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "397934789468",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:397934789468:web:c073393024058763f5b799",
  measurementId: "G-Q7YBG0YS4B"
};

// Initialize Firebase only if it hasn't been initialized yet
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Get Auth and Firestore instances
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app; 